<template>
  <div class="more-box">
    <img class="more-img" :src="bg"/>
    <main class="more-content">
      <!-- <p>下载尤果圈</p>
      <p class="more-tip">查看更多内容</p>
      <a class="more-btn" :href="NEW_UGIRL_URL">立即查看</a> -->
    </main>
  </div>
</template>
<script>
  export default {
    props: {
      bg: String
    }
  }
</script>
<style lang="scss" scoped>
  .more-box {
    position: relative;
  }
  .more-img {
    width: 100%;
    filter: blur(8px);
  }
  .more-content {
    position: absolute;
    top:0;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #FFF;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    .more-tip {
      margin-bottom: 10px;
    }
    .more-btn {
      display: inline-block;
      width: 120px;
      border: dashed 1px #FFF;
      padding: 5px;
      color: #FFF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/More.vue